/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Preview_PropertyInputs */

const cs_builder_preview_property = /** @type {(inputs: Builder_Preview_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inzerát`)
};

const en_builder_preview_property = /** @type {(inputs: Builder_Preview_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing`)
};

/**
* | output |
* | --- |
* | "Listing" |
*
* @param {Builder_Preview_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_preview_property = /** @type {((inputs?: Builder_Preview_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Preview_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_preview_property(inputs)
	return cs_builder_preview_property(inputs)
});